import { render } from "./DefaultLayout.vue?vue&type=template&id=3143ac47"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rlb-poc.prepare.servicedesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__